import {
  useClick,
  useFloating,
  useInteractions,
  shift,
  offset,
  autoUpdate,
  useDismiss,
  useTransitionStyles,
} from '@floating-ui/react';
import React, { useState } from 'react';

import Popup from './Popup';
import Trigger from './Trigger';

const Notification = () => {
  const [showNotifPopup, setShowNotifPopup] = useState(false);
  const { refs, floatingStyles, context } = useFloating({
    open: showNotifPopup,
    onOpenChange: setShowNotifPopup,
    whileElementsMounted: autoUpdate,
    middleware: [
      shift({
        padding: 20,
      }),
      offset({
        mainAxis: 7,
      }),
    ],
  });

  const click = useClick(context);
  const dismiss = useDismiss(context);
  const { isMounted, styles: transitionStyles } = useTransitionStyles(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
  ]);

  return (
    <>
      <Trigger ref={refs.setReference} getReferenceProps={getReferenceProps} />
      {isMounted && (
        <Popup
          ref={refs.setFloating}
          styles={{ ...floatingStyles, ...transitionStyles }}
          getFloatingProps={getFloatingProps}
          handleHidePopup={() => setShowNotifPopup(false)}
        />
      )}
    </>
  );
};

export default Notification;
